module.exports = __webpack_public_path__ + "img/demonstration-text-item-line.c78c9533.png";